module.exports = __webpack_public_path__ + "static/media/warningIcon.5a43e240.png";